/**
 * Terms API — 약관 최종 버전 조회.
 *
 * BE endpoint:
 *   GET /api/v1/user/terms/{divisionCode}/latest?lang=ko|en|ja   (public, 인증 불필요)
 *
 * 동작:
 *   - 현재 시점에 효력 발생 + 미만료 + 사용 중 약관 중 가장 최근 row 1건 반환.
 *   - 요청 언어의 번역본이 없으면 **정본(한국어) 본문**이 내려온다. 그때 응답의 `languageCode` 가
 *     요청 언어와 달라지므로, 화면은 이를 비교해 "원문 표시" 안내를 띄운다(반쯤 번역된 문서를
 *     만들어 내보내지 않는다는 정책).
 *   - BE 는 Redis `shared:terms:latest:{div}:{lang}` 캐시 우선. 어드민에서 CRUD 시 캐시 evict.
 *   - 응답.bodyContent 는 HTML 문자열 (admin RichTextEditor 출력 — h2/h3/ul/li/p 등).
 *     렌더 시 dangerouslySetInnerHTML 필요.
 *   - 미등록 시 BE 가 404 — caller 가 빈 영역으로 fallback 처리.
 */
import { apiGet } from "./client";

export interface LatestTerms {
  termsSerialNo: number;
  termsDivisionCommonCode: string;
  termsName: string;
  termsVersion: string;
  /** 실제 본문의 언어. 요청 언어와 다르면 번역본이 없어 정본으로 폴백된 것이다. */
  languageCode: string;
  mandatoryYn: string;
  /** HTML 문자열. BE 어드민이 sanitize 한 결과. 렌더 시 dangerouslySetInnerHTML. */
  bodyContent: string;
  effectiveStartDateTime: string;
  effectiveEndDateTime: string | null;
  updateAt: string | null;
}

export interface LatestTermsResponse {
  terms: LatestTerms;
}

export async function fetchLatestTerms(
  divisionCode: string,
  language: string,
): Promise<LatestTerms | null> {
  const data = await apiGet<LatestTermsResponse | null>(
    `/terms/${encodeURIComponent(divisionCode)}/latest?lang=${encodeURIComponent(language)}`,
  );
  return data?.terms ?? null;
}
